<ng-container *ngIf="isEnabled && account && dataset">
    <div class="panel-container">
        <div class="panel-header">
            <button
                (click)="addNotification()"
                mat-stroked-button
                class="notif-btn"
            >
                <mat-icon fontIcon="fa-plus" fontSet="far"></mat-icon>
                <span style="padding-left: 6px">Add Alerts</span>
            </button>
        </div>
        <div class="reports-container">
            <div
                *ngIf="showPanel && notificationsLoaded && !notifications.length"
                style="padding: 12px; color: #666; font-size: 0.75rem; font-style: italic"
            >
                No alerts yet. Create an alert to get started.
            </div>
            <div *ngFor="let notif of notifications; let i = index">
                <div class="notification-box" *ngIf="showPanel">
                    <div class="notification-container">
                        <map-event-notification
                            style="width: 100%"
                            [eligibleOverlays]="eligibleOverlays"
                            [eventNotif]="notif"
                            [currencies]="currencies"
                            [dataset]="dataset"
                            [groupsIds]="groupsIds"
                            [groups]="groups"
                            [layerExposeFields]="layerExposeFields"
                            [accountMemberEmails]="accountMemberEmails"
                            (deleteEventNotif)="deleteEventNotif($event)"
                        ></map-event-notification>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
